import gql from 'graphql-tag';

import integrationFragment from '../fragments/integrationFragment';

export const queryIntegrations = gql`
  query integrations {
    integrations {
      ...integrationFragment
    }
  }
  ${integrationFragment}
`;
export default queryIntegrations;
